export enum GameResultCategory {
  SUCCESS_FULL = 'success_full',
  MISSING_CORRECT = 'missing_correct',
  CONTAINS_WRONG = 'contains_wrong',
  FAIL = 'fail',
  UNDEFINED = 'undefined'
}
